namespace Areas.Dialogs.EditAccountCIBCost {
    "use strict";

    export class Calculations {
        readonly transform = new TransformData();
        readonly indices = new Indices();

        constructor() {
        }

        transformData(data: any) {
            return this.transform.execute(data, this.indices.keysAndDescriptions);
        }

        updateCalculations(grid: any, rowIndex: number, dataField: string, newValue: any) {
            if (rowIndex >= this.indices.p0Index && rowIndex <= this.indices.p8Index) {
                this.updateAllTotals(grid, dataField);
                this.updateRatios(grid, dataField);
            }

            if (rowIndex == this.indices.p9Index) {
                this.updatePWCTotalProjectAndGrandTotals(grid, dataField, newValue);
                this.updateRatios(grid, dataField);
            }

            if (rowIndex == this.indices.p3Index) {
                this.updateProjectAndGrandTotals(grid, dataField, newValue);
            }

            if (rowIndex == this.indices.p8iIndex) {
                this.updateGrandTotal(grid, dataField, newValue);
            }

            if (rowIndex == this.indices.proposedASFIndex 
                || rowIndex == this.indices.currentASFIndex
                || rowIndex == this.indices.currentOGSFIndex 
                || rowIndex == this.indices.p3Index) {
                this.updateRatios(grid, dataField);
            }
        }

        public updateAllTotals(grid: any, dataField: string) {
            const subtotalKeys = ["P0", "P1", "P2", "P4", "P5", "P6", "P7", "P8"];

            const subTotal = grid
                .getVisibleRows()
                .filter((x: any) => subtotalKeys.includes(x.key))
                .map((d: any)=> Number(d.data[dataField]))
                .reduce((total: number, current: number) => { return total + current; }, 0);

            grid.cellValue(this.indices.subTotalIndex, dataField, subTotal);

            const pwcTotal = subTotal + this.getCurrentP9Value(grid, dataField);
            grid.cellValue(this.indices.pwcTotalIndex, dataField, pwcTotal);

            const projectTotal = pwcTotal + this.getCurrentP3Value(grid, dataField);
            grid.cellValue(this.indices.projectTotalIndex, dataField, projectTotal);

            const grandTotal = projectTotal + this.getCurrentP8iValue(grid, dataField);
            grid.cellValue(this.indices.grandTotalIndex, dataField, grandTotal);
        }

        private updatePWCTotalProjectAndGrandTotals(grid: any, dataField: string, p9newValue: any) {
            const pwcTotal = this.getCurrentSubTotal(grid, dataField) + Number(p9newValue);
            grid.cellValue(this.indices.pwcTotalIndex, dataField, pwcTotal);

            const projectTotal = pwcTotal + this.getCurrentP3Value(grid, dataField);
            grid.cellValue(this.indices.projectTotalIndex, dataField, projectTotal);

            const grandTotal = projectTotal + this.getCurrentP8iValue(grid, dataField);
            grid.cellValue(this.indices.grandTotalIndex, dataField, grandTotal);
        }

        private updateProjectAndGrandTotals(grid: any, dataField: string, p3newValue: any) {
            const projectTotal = this.getCurrentPWCTotal(grid, dataField) + Number(p3newValue);
            grid.cellValue(this.indices.projectTotalIndex, dataField, projectTotal);

            const grandTotal = projectTotal + this.getCurrentP8iValue(grid, dataField);
            grid.cellValue(this.indices.grandTotalIndex, dataField, grandTotal);
        }

        private updateGrandTotal(grid: any, dataField: string, p8inewValue: any) {
            const grandTotal = this.getCurrentProjectTotal(grid, dataField) + Number(p8inewValue);
            grid.cellValue(this.indices.grandTotalIndex, dataField, grandTotal);
        }

        private updateRatios(grid: any, dataField: string) {
            const proposedASFValue = this.getCurrentProposedASFValue(grid, dataField);
            const currentASFValue = this.getCurrentCurrentASFValue(grid, dataField);
            const currentOGSFValue = this.getCurrentCurrentOGSFValue(grid, dataField);
            const currentP1Value = this.getCurrentP1Value(grid, dataField);
            const currentP2Value = this.getCurrentP2Value(grid, dataField);
            const currentP3Value = this.getCurrentP3Value(grid, dataField);
            const currentPWCTotalValue = this.getCurrentPWCTotal(grid, dataField);

            const aSFGSFRatio = currentOGSFValue != 0 ? proposedASFValue / currentOGSFValue : 0;
            const buildingCostGSFRatio = currentOGSFValue != 0 ? currentP1Value / currentOGSFValue : 0;
            const buildingCostASFRatio = currentASFValue != 0 ? currentP1Value / currentASFValue : 0;
            const pWCGSFRatio = currentOGSFValue != 0 ? currentPWCTotalValue / currentOGSFValue : 0;
            const pWCASFRatio  = currentASFValue != 0 ? currentPWCTotalValue / currentASFValue : 0;
            const p2P3ASFRatio = currentASFValue != 0 ? (currentP2Value + currentP3Value) / currentASFValue : 0;

            grid.cellValue(this.indices.ASFGSFRatioIndex, dataField, aSFGSFRatio);
            grid.cellValue(this.indices.BuildingCostGSFRatioIndex, dataField, buildingCostGSFRatio);
            grid.cellValue(this.indices.BuildingCostASFRatioIndex, dataField, buildingCostASFRatio);
            grid.cellValue(this.indices.PWCGSFRatioIndex, dataField, pWCGSFRatio);
            grid.cellValue(this.indices.PWCASFRatioIndex, dataField, pWCASFRatio);
            grid.cellValue(this.indices.P2P3ASFRatioIndex, dataField, p2P3ASFRatio);
        }

        private getCurrentProposedASFValue(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.proposedASFIndex, dataField);
            return Number(value);
        }

        private getCurrentCurrentASFValue(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.currentASFIndex, dataField);
            return Number(value);
        }

        private getCurrentCurrentOGSFValue(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.currentOGSFIndex, dataField);
            return Number(value);
        }

        private getCurrentP1Value(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.p1Index, dataField);
            return Number(value);
        }

        private getCurrentP9Value(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.p9Index, dataField);
            return Number(value);
        }

        private getCurrentP2Value(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.p2Index, dataField);
            return Number(value);
        }

        private getCurrentP3Value(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.p3Index, dataField);
            return Number(value);
        }

        private getCurrentP8iValue(grid: any, dataField: string) : number {
            var value = grid.cellValue(this.indices.p8iIndex, dataField);
            return Number(value);
        }

        private getCurrentSubTotal(grid: any, dataField: string): number {
            const value = grid.cellValue(this.indices.subTotalIndex, dataField);
            return Number(value);
        }

        private getCurrentPWCTotal(grid: any, dataField: string): number {
            const value = grid.cellValue(this.indices.pwcTotalIndex, dataField);
            return Number(value);
        }

        private getCurrentProjectTotal(grid: any, dataField: string): number {
            const value = grid.cellValue(this.indices.projectTotalIndex, dataField);
            return Number(value);
        }

    }

}
